import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "image-pre-load" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.initStoreDataComplete && _ctx.initSiteDataComplete)
      ? (_openBlock(), _createBlock(_component_ConfigProvider, {
          key: 0,
          locale: _ctx.$tm('thirdParty.antDesign')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RouterView)
          ]),
          _: 1
        }, 8, ["locale"]))
      : _createCommentVNode("", true),
    _hoisted_1
  ], 64))
}